import React from "react";
import { TriggerForm } from "./TriggerForm";
import TriggerGrid from "./TriggerGrid";

const TriggerVendorMaster = () => {
  return (
    <>
      <TriggerForm/>
      <TriggerGrid/>
    </>
  );
};

export default TriggerVendorMaster;